import React from 'react'
import { Page } from '../components/ui/Page'
import { Body } from '../components/layout/Body';

export default function ImprintPage() {
    return (
        <div className="max-w-[1200px] mx-auto">
            <Page>
                <Body>
                    <h1 className='text-2xl mt-16 mb-8 font-bold'>Impressum</h1>
                    <p>Offenlegung gemäß § 25 MedienG, § 5 ECG und § 14 UGB <br /> Plattform: <a href="https://digital-sky.jtm.digital" target="_blank" rel="noreferrer" className="text-[#E1320F] underline font-medium">Digital Sky</a></p>

                    <h2 className='text-lg'>Medieninhaber und Herausgeber</h2>
                    <p><strong>JTM digital GmbH im Auftrag des Bundesministeriums für Finanzen (BMF)</strong></p>
                    <p>
                        JTM digital GmbH<br />
                        Peregringasse 2<br />
                        1090 Wien<br />
                        Österreich
                    </p>
                    <p>
                        Website: <a href="https://www.jtm.digital" target="_blank" rel="noreferrer" className="text-[#E1320F] underline font-medium">https://www.jtm.digital</a>
                    </p>
                    <p>Im Auftrag des Bundesministeriums für Finanzen (BMF), Johannesgasse 5, 1010 Wien.</p>

                    <h3>Vertretungsbefugte Organe</h3>
                    <p>Die Geschäftsführung der JTM digital GmbH.</p>

                    <h2 className='text-lg'>Plattformbetrieb</h2>
                    <p>Die Plattform „Digital Sky" (https://digital-sky.jtm.digital) wird von der JTM digital GmbH im Auftrag des Bundesministeriums für Finanzen betrieben und dient der Abwicklung von Drohnenflügen sowie damit verbundener Dienstleistungen und Käufe.</p>

                    <h3>Technische Umsetzung</h3>
                    <p>Die technische Entwicklung und der Betrieb der Plattform erfolgen durch:</p>
                    <p>
                        JTM digital GmbH<br />
                        Peregringasse 2<br />
                        1090 Wien<br />
                        Austria
                    </p>
                    <p>Im Auftrag des Bundesministeriums für Finanzen.</p>

                    <h2 className='text-lg'>Aufsichtsbehörde</h2>
                    <p>
                        Bundesministerium für Kunst, Kultur, öffentlichen Dienst und Sport (als oberste Dienstbehörde)<br />
                        Ballhausplatz 2<br />
                        1010 Wien
                    </p>

                    <h2 className='text-lg'>Anwendbares Recht</h2>
                    <p>Österreichisches Recht. Gerichtsstand ist Wien.</p>

                    <h2 className='text-lg'>Grundlegende Richtung der Plattform</h2>
                    <p>Die Plattform „Digital Sky" dient als digitale Service-Plattform des Bundesministeriums für Finanzen zur Verwaltung, Beantragung und Abwicklung von Drohnenflugbewilligungen im österreichischen Luftraum. Sie ermöglicht registrierten Nutzerinnen und Nutzern die Buchung und den Erwerb entsprechender Bewilligungen und Dienstleistungen.</p>

                    <h2 className='text-lg'>Urheberrecht</h2>
                    <p>Die auf dieser Plattform veröffentlichten Inhalte (Texte, Bilder, Grafiken, Daten) unterliegen dem österreichischen Urheberrecht. Jede Vervielfältigung, Verbreitung oder sonstige Verwertung bedarf der vorherigen schriftlichen Zustimmung des Bundesministeriums für Finanzen, sofern nicht gesetzlich anders geregelt.</p>
                    <p className="mt-2">Falls Sie der Ansicht sind, dass auf dieser Plattform Inhalte Ihre Urheberrechte verletzen, ersuchen wir Sie, uns dies umgehend zu melden.</p>
                    <div className="mt-3">
                        <a
                            href="mailto:post@bmf.gv.at?subject=Meldung%20Urheberrechtsverletzung"
                            className="text-[#E1320F] underline font-medium"
                        >
                            Urheberrechtsverletzung melden
                        </a>
                    </div>

                    <h2 className='text-lg'>Haftungsausschluss</h2>
                    <p>Die Inhalte dieser Plattform wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird keine Gewähr übernommen. Das Bundesministerium für Finanzen haftet nicht für Schäden, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen entstehen.</p>
                    <p>Für den Inhalt externer Links übernimmt das Bundesministerium für Finanzen keine Haftung. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Zum Zeitpunkt der Verlinkung waren keine rechtswidrigen Inhalte erkennbar.</p>

                    <h2 className='text-lg'>Barrierefreiheit</h2>
                    <p>Das Bundesministerium für Finanzen ist bemüht, die Plattform „Digital Sky" barrierefrei gemäß den Bestimmungen des Web-Zugänglichkeits-Gesetzes (WZG) und der EU-Richtlinie 2016/2102 zugänglich zu machen. Bei Problemen oder Anregungen zur Barrierefreiheit wenden Sie sich bitte an: [E-Mail-Adresse]</p>

                    <p className="text-gray-500 text-sm">Stand: März 2026</p>
                </Body>

            </Page>
        </div>
    )
}
